module.exports = __webpack_public_path__ + "img/no_sc.e2404d95.png";